import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteJudgingQuestion: (
  fetchContext: FetchContext,
  awardId: number,
  questionId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, awardId, questionId, accessToken) => fetch(`${fetchContext.baseUrl}/api/admin/awards/${awardId}/judging-questions/${questionId}`,
  {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete judging question'));
